import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Media from 'sb-media'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Carousel from 'components/ui/Carousel/Carousel'
import Product from 'components/product/Product/Product'
import DialogModal from 'components/modals/DialogModal/DialogModal'
import { ContentWithLoader } from 'components/_new/ui'

import messages from './messages'
import s from './RecommendationsModal.scss'


const carouselOptions = {
  dots: false,
  swipe: true,
  arrows: true,
  infinite: true,
  autoplay: false,
  touchMove: true,
  slidesToShow: 4,
  slidesToScroll: 2,
  responsive: [ {
    breakpoint: constants.media.tabletLandscapeEnd,
    settings: {
      slidesToShow: 3,
    },
  }, {
    breakpoint: constants.media.tabletLandscapeStart,
    settings: {
      slidesToShow: 2,
    },
  } ],
}

class RecommendationsModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    productId: PropTypes.number,
    data: PropTypes.shape({
      isSkincareGroup: PropTypes.bool,
    }),
  }

  static defaultProps = {
    name: constants.modals.review.Recommendations,
  }

  state = {
    isFetching: true,
    recommendations: [],
  }

  componentDidMount() {
    const { productId, data: { isSkincareGroup } } = this.props

    const action = isSkincareGroup
      ? actions.models.review.fetchSkincareRecommendations
      : actions.models.review.fetchRecommendations

    action(productId)
      .then(
        (recommendations) => this.setState({
          recommendations,
          isFetching: false,
        }),
        () => this.setState({ isFetching: false })
      )
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  renderProducts = () => {
    const { recommendations } = this.state

    const metadata = {
      placement: 'review recommendations',
    }

    const snowplowMetadata = {
      placement: 'review recommendations modal', // TODO SNOWPLOW check if correct
    }

    return (
      recommendations.map((item, index) => (
        <div key={index} className={s.item}>
          <Product
            data={item}
            addTo="queue"
            link={item.link}
            buttonTitle={messages.fragranceButtonTitle}
            isHoverEffect={false}
            isQuickViewVisible={false}
            onBlockClick={this.close}
            metadata={metadata}
            snowplowMetadata={snowplowMetadata}
          />
        </div>
      ))
    )
  }

  render() {
    const { isFetching } = this.state
    const { name, data: { isSkincareGroup } } = this.props

    const title = isSkincareGroup ? messages.thankYouTitle : messages.title

    return (
      <DialogModal className={s.modal} title={title} name={name} isWhiteButton>
        {
          isSkincareGroup && (
            <FormattedHTMLMessage className={s.subTitle} tag="div" {...messages.subTitle} />
          )
        }
        <ContentWithLoader isFetching={isFetching}>
          <Media mobile>
            {
              (isMobile) => isMobile ? (
                <div className={s.items}>
                  {this.renderProducts()}
                </div>
              ) : (
                <Carousel className={s.carousel} options={carouselOptions}>
                  {this.renderProducts()}
                </Carousel>
              )
            }
          </Media>
        </ContentWithLoader>
      </DialogModal>
    )
  }
}


export default connect({
  items: 'models.review.items',
  productId: 'models.review.product.id',
  isFirstStep: 'models.review.isFirstStep',
})(RecommendationsModal)
